import React from 'react'
import PrilimsSection from '../components/syllabus/prilimsSection'
import MainsExamination from '../components/syllabus/MainsExamination'
import OptionalSubjects from '../components/syllabus/Optionalsyllus'
function SyllabusPage() {
  return (
    <div>
        <PrilimsSection/>
        <MainsExamination/>
        <OptionalSubjects/>
        
    </div>
  )
}

export default SyllabusPage